import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f9e438e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "closed-sign"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "img/closed-sign.svg" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  id: "cart-container"
}
const _hoisted_5 = {
  key: 0,
  id: "cart-count"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " shopping_cart ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Cart Summary", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 2,
  id: "home"
}
const _hoisted_10 = { id: "presents" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("West Point Church "),
  /*#__PURE__*/_createElementVNode("span", null, "Presents")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteHeader = _resolveComponent("SiteHeader")!
  const _component_CartSummary = _resolveComponent("CartSummary")!
  const _component_ProductList = _resolveComponent("ProductList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SiteHeader),
    (!_ctx.isEmpty(_ctx.settings) && !_ctx.settings?.cartOn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.settings?.cartOn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            id: "cart-icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleCart()))
          }, [
            (_ctx.totalProductCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.totalProductCount), 1))
              : _createCommentVNode("", true),
            _hoisted_6
          ]),
          _createElementVNode("div", {
            id: "mini-cart",
            class: _normalizeClass({ active: _ctx.isCartActive })
          }, [
            _hoisted_7,
            (_ctx.productsLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_CartSummary, {
                    onCartExpired: _ctx.alertExpiredCart,
                    onCart: _ctx.setCartContents,
                    onUpdateEvent: _ctx.productsRefresh,
                    forceRefresh: _ctx.cartForceRefresh
                  }, null, 8, ["onCartExpired", "onCart", "onUpdateEvent", "forceRefresh"]),
                  (_ctx.products.length && !_ctx.isCartExpired)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('checkout')))
                      }, "Checkout"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.settings?.cartOn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("h3", null, _toDisplayString(_ctx.settings?.title), 1)
          ]),
          _createVNode(_component_ProductList, {
            onProductsLoaded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.productsLoaded = $event)),
            onUpdateEvent: _ctx.cartUpdate,
            forceRefresh: _ctx.productsForceRefresh
          }, null, 8, ["onUpdateEvent", "forceRefresh"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}